import React from 'react'

export function IconTituloTextoComponent({ fill = '#2F5DC9', height = '17', width = '17' }: { fill?: string, height?: string, width?: string }) {
  return (
    <svg width={width} height={height} viewBox="0 0 16 15" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M14.16 0L15.32 4.35L14.36 4.61C13.91 3.74 13.45 2.87 12.92 2.43C12.39 2 11.77 2 11.16 2H8.66V12.5C8.66 13 8.66 13.5 8.99 13.75C9.33 14 9.99 14 10.66 14V15H4.66V14C5.33 14 5.99 14 6.33 13.75C6.66 13.5 6.66 13 6.66 12.5V2H4.16C3.55 2 2.93 2 2.4 2.43C1.87 2.87 1.41 3.74 0.96 4.61L0 4.35L1.16 0H14.16Z" fill={fill} />
    </svg>
  )
}
